import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import transition from '../../utils/transition.js';
import createResponsive from '../../utils/createResponsive.js';
import { disabledStyles, focusStyles } from '../../utils/styled.js';
import { ChevronUp, ChevronDown } from '@indeed/ifl-icons';
import { jsx } from '@emotion/react';
import { Flex } from '../Flex/Flex.js';
import { Box } from '../Box/Box.js';

// ----------------------
// SIZES
// ----------------------

const sizes = {
  sm: {
    minBlockSize: "2.125rem",
    paddingBlock: "scb2"
  },
  md: {
    minBlockSize: "2.625rem",
    paddingBlock: "scb3"
  }
};
const getMinBlockSize = createResponsive(size => sizes[size].minBlockSize);
const getPaddingBlock = createResponsive(size => sizes[size].paddingBlock);

// ----------------------
// STYLES
// ----------------------

const selectListTriggerStyles = _ref => {
  let {
    invalid,
    size = "md"
  } = _ref;
  return {
    // Reset stuff
    boxSizing: "border-box",
    position: "relative",
    cursor: "pointer",
    outlineStyle: "solid",
    outlineColor: "transparent",
    outlineWidth: "0px",
    outlineOffset: "0px",
    // Visual styles
    bg: "background",
    border: "1px solid",
    borderColor: invalid ? "border.status.critical.strong" : "border.action",
    borderRadius: "md",
    color: "foreground.strong",
    fontFamily: "default",
    fontSize: 3,
    // Display
    display: "flex",
    alignItems: "center",
    // Size and space
    gap: 1,
    inlineSize: "100%",
    minBlockSize: getMinBlockSize(size),
    paddingBlock: getPaddingBlock(size),
    paddingInline: 3,
    // Motion
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.default, "border-color", "outline-color", "outline-width", "outline-offset");
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none"
    },
    // Interactions
    ":hover::before": {
      borderColor: invalid ? "border.status.critical.strong" : "border.action.hover"
    }
  };
};

// ----------------------
// StyledSelectListTrigger
// ----------------------

const propsNotForwarded = new Set(["contentAfter", "contentBefore", "invalid", "isOpen", "size"]);
const StyledSelectListTrigger = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: ["disabled", "invalid", "size"],
  shouldForwardProp: prop => !propsNotForwarded.has(prop),
  target: "ec1hp250"
} : {
  styleProps: ["disabled", "invalid", "size"],
  shouldForwardProp: prop => !propsNotForwarded.has(prop),
  target: "ec1hp250",
  label: "StyledSelectListTrigger"
})(selectListTriggerStyles, disabledStyles, focusStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

// ----------------------
// SelectListTrigger
// ----------------------

const SelectListTrigger = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    children,
    contentAfter,
    contentBefore,
    disabled = false,
    invalid = false,
    isOpen = false,
    size = "md"
  } = props;
  return jsx(StyledSelectListTrigger, _extends({
    disabled: disabled,
    invalid: invalid,
    ref: forwardedRef,
    size: size,
    tabIndex: disabled ? -1 : 0
  }, props), contentBefore && jsx(Flex, {
    as: "span",
    sx: {
      color: "foreground.weak",
      flexShrink: 0,
      justifyContent: "center",
      minInlineSize: "24px"
    }
  }, contentBefore), jsx(Box, {
    as: "span",
    sx: {
      overflow: "hidden",
      flexGrow: 1,
      whiteSpace: "nowrap",
      textAlign: "start"
    }
  }, children), contentAfter && jsx(Flex, {
    as: "span",
    sx: {
      color: "foreground.weak",
      flexShrink: 0,
      justifyContent: "center",
      minInlineSize: "24px"
    }
  }, contentAfter), jsx(Flex, {
    as: "span",
    sx: {
      flexShrink: 0
    }
  }, isOpen ? jsx(ChevronUp, {
    "aria-hidden": true
  }) : jsx(ChevronDown, {
    "aria-hidden": true
  })));
});

export { SelectListTrigger };
